import { times } from 'lodash';

export default function getColumnValues({ board, columnIndex }) {
  const columnValues = [];
  times(board.length, (rowIndex) => { columnValues.push(board[rowIndex][columnIndex]); });

  return columnValues;
}
